export enum FlexBoxJustifyContent {
  Start = 'Start',
  Center = 'Center',
  End = 'End',
  SpaceAround = 'SpaceAround',
  SpaceBetween = 'SpaceBetween'
}
